// extracted by mini-css-extract-plugin
export default {"grid":"em2_d","viewVertical":"gEIKg","image":"c_p9V","viewHorizontal":"aUVxM","cnImage":"ip4A3","sign":"Xvn7p","blockquote":"ZAMd6","text":"Ucd9U"};